import { ErrorCode } from '@app/services/SettingAxios';
import { ErrorUserLk } from '../ErrorUserLk';
import { TitleList } from '../../WrapperList/TitleList';
import { Fragment } from 'react';

export const WrapperErrorLk = ({ error, title, children }) => {
  const errorCodes = Object.values(ErrorCode);
  const isError = errorCodes.includes(error?.code);

  if (isError) {
    return (
      <Fragment>
        <TitleList title={title} />
        <ErrorUserLk />
      </Fragment>
    );
  }
  return children;
};
